import React from 'react';
import '../assets/css/footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-content">
                <p>© 2025 Maryland Express Fundraising. All Rights Reserved.</p>
                <p>
                    <a href="/contact" className="footer-link">
                        Contact Us
                    </a>
                </p>
            </div>
        </footer>
    );
};

export default Footer;